import RevisionIcon from "assets/icon/RevisionIcon";
import TrashIcon from "assets/icon/TrashIcon";

export default function GridDeleteButton({ onClick, isActive, size = 'w-4', fill = 'fill-white' }) {
    return (
        <button className={`bg-black rounded-lg p-2 flex gap-2`} onClick={onClick}>
            {
                isActive === '1' ? 
                (<TrashIcon className={`${size} ${fill}`} />) : 
                (<RevisionIcon className={`${size} ${fill}`} />)
            }
        </button>
    )
}